import type { Campaign, CampaignPriority } from '~/types/graphql';
import type { IAnalyticMetric } from '~/types/metric';
import type { IconSource } from '@shopify/polaris';

import { useShowMakeWinnerButton } from '~/modules/campaign-analytics';
import { useTemplateStatus } from '~/modules/campaign-template';
import { useWindowSize } from '~/presentation/common';
import { useTranslation } from 'react-i18next';
import { GButton } from '~/presentation/ui';

interface MakeWinnerButtonProps {
  campaign?: Campaign;
  metrics: IAnalyticMetric[];
  goal?: CampaignPriority;
  icon?: IconSource;
  onClick?: () => void;
}
export const MakeWinnerButton = ({
  campaign,
  metrics,
  goal,
  icon,
  onClick,
}: MakeWinnerButtonProps) => {
  const { t } = useTranslation();

  const { isMobileView } = useWindowSize();

  const { isShowMakeWinnerButton } = useShowMakeWinnerButton({
    campaign,
    metrics,
    goal,
  });
  const { hasUnpublishedOrDeleted } = useTemplateStatus({
    campaign,
  });

  if (!isShowMakeWinnerButton) return;

  return (
    <GButton
      disabled={hasUnpublishedOrDeleted}
      tooltip={{
        content: hasUnpublishedOrDeleted
          ? t(
              "winner can't be selected because one of the templates has been unpublished or deleted",
            )
          : '',
      }}
      icon={icon}
      iconRight={!!icon}
      onClick={onClick}
      fullWidth={isMobileView}
    >
      {t('Make winner')}
    </GButton>
  );
};
